/* Tab switching for snippets/smartfits-info-tabs.liquid. */
(function () {
  class SmartfitsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      });
      this.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(document.activeElement);
        if (index === -1) return;
        let next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (next === null) return;
        event.preventDefault();
        this.tabs[next].focus();
        this.select(this.tabs[next]);
      });
    }

    select(tab) {
      this.tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      this.panels.forEach((p) => {
        p.hidden = p.id !== tab.getAttribute('aria-controls');
      });
    }
  }

  if (!customElements.get('smartfits-tabs')) customElements.define('smartfits-tabs', SmartfitsTabs);
})();
